import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * The user closes out of the heatmap filter menu.
 */
const logHeatmapFilterMenuClosed = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('heatmap filter menu closed', {}, callback);
};

export default logHeatmapFilterMenuClosed;
